import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Heart } from "lucide-react";

export default function FamilyAccept() {
  const [state, setState] = useState("Checking your link…");
  const [error, setError] = useState(false);
  const done = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    window.history.replaceState({}, document.title, "/family/accept");
    if (!token) { setState("This link is invalid or has expired."); setError(true); return; }
    api.post("/family/exchange", { token })
      .then(({ data }) => {
        localStorage.setItem("kindred_family_token", data.session_token);
        localStorage.setItem("kindred_family_name", data.seeker_name);
        navigate("/family", { replace: true });
      })
      .catch((err) => { setState(formatError(err.response?.data?.detail)); setError(true); });
  }, [navigate]);

  return (
    <div data-testid="family-accept" className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white border border-[#E2D9CE] rounded-2xl p-8 max-w-md text-center shadow-sm">
        <span className="w-14 h-14 rounded-2xl bg-[#D96B43] inline-flex items-center justify-center"><Heart className="w-7 h-7 text-white" fill="white" /></span>
        <h1 className="text-2xl font-display font-bold text-slate-900 mt-4">Kindred Family View</h1>
        <p data-testid="family-accept-status" className={`text-lg mt-3 ${error ? "text-red-700" : "text-slate-600"}`}>{state}</p>
        {error && <p className="text-slate-500 mt-2">Ask your family member to open Kindred → Profile → Family View → “Send link again”.</p>}
      </div>
    </div>
  );
}
